(function () {
  const KEY = "inkd_sticky_pop_hidden_v1";
  const el = document.getElementById("inkdStickyPop");
  if (!el) { console.warn("[inkdStickyPop] element not found"); return; }

  const FORCE_SHOW = false;

  const wasHidden = sessionStorage.getItem(KEY) === "1";
  if (wasHidden && !FORCE_SHOW) {
    console.info("[inkdStickyPop] suppressed by sessionStorage key:", KEY);
    el.hidden = true;
    el.classList.remove("is-open");
    return;
  }

  el.hidden = false;
  requestAnimationFrame(() => {
    setTimeout(() => el.classList.add("is-open"), 250);
  });

  const closeBtn   = el.querySelector(".inkdStickyPop__close");

  const dontBtn    = document.getElementById("inkdStickyPopDontShow");

  const learnLinks = el.querySelectorAll(
    'a.inkdStickyPop__btn, a.inkdStickyPop__mobileLink, a[href*="webstore"]'
  );

  function closePop() {
    el.classList.remove("is-open");
    setTimeout(() => { el.hidden = true; }, 220);
  }

  function closeAndRemember() {
    try { sessionStorage.setItem(KEY, "1"); } catch(e) {}
    closePop();
  }

  closeBtn && closeBtn.addEventListener("click", closeAndRemember);

  dontBtn && dontBtn.addEventListener("click", closeAndRemember);

  learnLinks.forEach((a) => {
    a.addEventListener("click", closeAndRemember);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !el.hidden) closePop();
  });

  window.addEventListener("pageshow", () => {
    const hidden = sessionStorage.getItem(KEY) === "1";
    if (hidden && !FORCE_SHOW) {
      el.hidden = true;
      el.classList.remove("is-open");
    }
  });

  console.info("[inkdStickyPop] mounted", { wasHidden, FORCE_SHOW });
})();
